/**
 * Delete forever exists only on an archived record. A live record is archived
 * first (and can be restored); only once it is in the archive does the screen
 * offer to remove it for good, and the API refuses otherwise.
 *
 * Records carry that state under a few names depending on how old the table
 * is: `archived`, `archived_at`, or (for the trash stage) `trashed_at` /
 * `deletedAt`. Any of them counts.
 */
export interface Archivable {
  archived?: boolean | null;
  archived_at?: string | null;
  archivedAt?: string | null;
  trashed_at?: string | null;
  deletedAt?: string | null;
}

export function canDeleteForever(record: Archivable | null | undefined): boolean {
  if (!record) return false;
  return record.archived === true
    || !!record.archived_at
    || !!record.archivedAt
    || !!record.trashed_at
    || !!record.deletedAt;
}
